import * as Types from './types';
import { actionTypes } from './constants';

export const hideFooter = (): Types.IHideFooterAction => ({
    type: actionTypes.HIDE_FOOTER
});

export const showFooter = () : Types.IShowFooterAction => ({
    type: actionTypes.SHOW_FOOTER
});
